import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToggleInput } from './../../../models';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
    selector: 'lib-switch-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, InputSwitchModule],
    template: `
        <p-inputSwitch
            [formControl]="control"
            inputId="{{ 'input-' + name }}"
            [name]="name"
            [styleClass]="control.styleClass"
            [trueValue]="control.trueValue"
            [falseValue]="control.falseValue"
        >
        </p-inputSwitch>
    `,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ]
})
export class SwitchInputComponent extends BaseInputComponent<string> {
    @Input() name!: string;
    @Input() override control!: ToggleInput;
}
